import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { BankStatementsFormViewForExtend } from "@pages/banks/bankStatements/BankStatementsFormView";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

class LoanStatementsFormView extends BankStatementsFormViewForExtend {
    documentType = DocumentTypeCode.LoanTransaction;

    getAccounts = () => {
        return this.context.getLoanAccounts(true) || [];
    }
}

export default withPermissionContext(LoanStatementsFormView);